// extracted by css-extract-rspack-plugin
export default {"title-container":"RequisitesPayersSelect-module__title-container--uAjWU","titleContainer":"RequisitesPayersSelect-module__title-container--uAjWU"};